export default __webpack_public_path__ + "static/media/mocduc.18a4b81c.png";